export class BillpayResponse {
    accountNumber: string;

    amountDue: number;
    currentBalance: number;
    pastDueAmount: number;

    constructor(value: any) {
        this.accountNumber = value.accountNumber;
        this.amountDue = value.amountDue || 0;
        this.pastDueAmount = value.pastDueAmount || 0;

        /**
         * Amdocs logic for currentBalance  always include pastDueAmount
         * Therefore real current balance is  {currentBalance – pastDueAmount}
         * see https://b2bsoft.atlassian.net/browse/CRT-1794
         */
        this.currentBalance = value.currentBalance - value.pastDueAmount || 0;
    }

    get totalDueAmount(): number {
        return this.pastDueAmount + this.currentBalance;
    }
}